import { AGENT_PORTAL_URL, AGENT_SERVER_URL, API_URL, APP_LIVE_URL, APP_URL, COMPANY_NAME, THEME_COLOR, THEME_TEXT_COLOR, columnsServices, dateString } from "../../../config/config";
import { getAdminReportGroup, getAgentReportGroup, getClientReportGroup, getAllReportsListing, addReportsGroup, getSingleGroup, updateReportsGroup, deleteGroup } from "./../../../config/metabase_api_calls";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";
import localization from "../../../localization/enUS";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import axios from "axios";
import $ from "jquery";
import moment from "moment";
import dateFormat, { masks } from "dateformat";
import * as XLSX from "xlsx";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import { extendMoment } from "moment-range";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { addSettings } from "../../../actions";
import { Link } from "react-router-dom";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import Tooltip from "@material-ui/core/Tooltip";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import HomeIcon from "@material-ui/icons/Home";
import TextField from "../../../components/InputFields/TextField";
import MutextField from "@material-ui/core/TextField";
import DataTable from "../../../components/Tables/DataTableReports";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

const extendedMoment = extendMoment(moment);

const animatedComponents = makeAnimated();

const auth = new HelperClass();

class ReportGroups extends Component {
  constructor() {
    var date = (date = new Date()),
      y = date.getFullYear(),
      m = date.getMonth();

    var datestring = new Date().toISOString().slice(0, 10);

    super();
    this.decimalPoint = Number(auth.getDecimalPoint());
    this.billing_decimalPoint = Number(auth.getBillingDecimalPoint());
    const today = extendedMoment();
    const monthAgo = moment().subtract(1, "month");
    this.state = {
      tableData: [],
      tableLoader: true,
      tableLoaderAgents: true,
      tableLoaderClients: true,
      adminGroupData: [],
      agentGroupData: [],
      clientGroupData: [],
      columnsArrayAgent: [],
      columnsArrayClient: [],
      combinedReportListing: [],
      //start_date: monthAgo.format("YYYY-MM-DD"),
      //end_date: today.format("YYYY-MM-DD"),
      start_date: "",
      end_date: "",
      selected_order_accountno: null,
      selected_client_accountno: null,
      selected_agent_accountno: null,
      selected_report_id: "",
      value: moment.range(monthAgo, today),
      commission_title_array: "get_commission_reports",
      commissionReportsArray: [],
      all_active_agents: [],
      all_active_clients: [],
      all_complete_orders: [],
      deposit_main_section: false,
      depositErrorMessage: "",
      depositSuccessMessage: "",
      emailto: "",
      emailcc: "",
      emailbcc: "",
      emailsubject: "",
      emailcontent: "",
      email_button: false,
      emailErrorMessage: "",
      emailErrorMessageTitle: "",
      emailSuccessMessage: "",
      orderno: "",
      form_title: "",
      formDetails: [],
      formGroups: [],
      is_submitted: "",
      payment_method_title: "",
      selected_payment_method: "",
      paymentDetails: [],
      requestDetails: [],
      request_main_section: true,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
      commission_amount: 0,
      payment_amount: (0).toFixed(this.billing_decimalPoint),
      payment_receipt: "",
      payment_notes: "",
      payment_date: new Date(),
      payment_method_pay: "Quickbooks",
      add_picture: "",
      add_picture_name: "",
      fundErrorMessageTitle: "",
      fundErrorMessage: "",
      fundSuccessMessage: "",
      add_funds_button: false,
      agent_pending_commision: 0,
      agent_paid_commision: 0,

      successMessage: "",
      errorMessage: "",
      document_file: "",
      csvData: [],

      selectedRows: [],
      bulkAction: "",

      report_id: "",

      permissionsState: [],
      permission_add: 0,
      permission_edit: 0,
      permission_delete: 0,
      permission_view: 0,
      permission_view_settings: 0,
      permission_view_clients: 0,

      groupType: "",
      modalTitle: "",
      modalText: "",
      group_name: "",
      group_seqno: "",
      group_status: "active",
      group_desc: "",
      groupTypeDel: "",
      selectAllClients: false,
      clientsList: [],
      selectedClients: [],
      group_id: "",
      delete_button_loader: false,

      modalTitleEdit: "",
      modalTextEdit: "",
      group_name_edit: "",
      group_seqno_edit: "",
      group_status_edit: "active",
      group_desc_edit: "",
      selectAllReports: false,
      reportList: [],
      selectedReports: [],
      group_id_edit: "",
      edit_button_loader: false,
      groupMenuTab: localStorage.getItem("groupMenuTab") || "admin_groups",

      columnsArray: [
        { name: "seqno", label: "Seq #" },
        { name: "group_name", label: "Group Name" },
        /*{
          name: "id",
          label: "Assigned Reports",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setReportLink(value, tableMeta)}</div>;
            },
          },
        },*/
        {
          name: "group_desc",
          label: "Group Description",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setGroupDesc(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "status",
          label: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "id",
          label: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setEditLink(value, "admin")}</div>;
            },
          },
        },
      ],
    };
  }

  async componentDidMount() {
    this.loadPermissions();
    console.log("group_type: ", this.props.props.match.params.group_type);
    let group_type = this.props.props.match.params.group_type;
    const savedTab = localStorage.getItem("groupMenuTab") || "admin_groups";
    if (savedTab === "" || savedTab === "admin_groups") {
      await this.getAdminGroups();
    } else if (savedTab === "agent_groups") {
      await this.getAgentGroups();
    } else if (savedTab === "client_groups") {
      await this.getClientGroups();
    } else {
      await this.getAdminGroups();
    }
  }

  loadPermissions = () => {
    if (!this.props.userRoleItems) return;
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "reports",
      "admin_reports"
    );
    // console.log("Can Edit Clients:", canEdit);

    this.setState({
      permissionsState: canEdit,
      permission_add: canEdit[0].add,
      permission_edit: canEdit[0].edit,
      permission_delete: canEdit[0].delete,
      permission_view: canEdit[0].view,
      permission_view_settings: canEdit[0].view_settings,
      permission_view_clients: canEdit[0].view_clients,
    });
    //console.log("Can Edit Clients:", canEdit);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      this.loadPermissions();
    }
  }

  getAdminGroups = async () => {
    const { report_id } = this.state;
    this.setState({
      diabled: true,
      report_id: report_id,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
    });
    // console.log("report_id: ", report_id);
    const reportsData = await getAdminReportGroup(
      auth.getAccount(),
      auth.getToken()
    );
    console.log("getAdminGroups: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({ tableLoader: false });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        adminGroupData: reportsData.data.data,
        tableLoader: false,
      });
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({ tableLoader: false });
    }
  };

  getAgentGroups = async () => {
    this.setState({ tableLoaderAgents: false });
    const { report_id } = this.state;
    this.setState({
      tableLoaderAgents: true,
      report_id: report_id,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
    });
    // console.log("report_id: ", report_id);
    const reportsData = await getAgentReportGroup(
      auth.getAccount(),
      auth.getToken()
    );
    console.log("getAgentGroups: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({ tableLoaderAgents: false });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        agentGroupData: reportsData.data.data,
        tableLoaderAgents: false,
        columnsArrayAgent: [
          { name: "seqno", label: "Seq #" },
          { name: "group_name", label: "Group Name" },
          /*{
          name: "id",
          label: "Assigned Reports",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setReportLink(value, tableMeta)}</div>;
            },
          },
        },*/
          {
            name: "group_desc",
            label: "Group Description",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.setGroupDesc(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.setStatus(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "id",
            label: "Action",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.setEditLink(value, "agents")}</div>;
              },
            },
          },
        ],
      });
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({ tableLoaderAgents: false });
    }
  };

  getClientGroups = async () => {
    const { report_id } = this.state;
    this.setState({
      tableLoaderClients: true,
      report_id: report_id,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
    });
    // console.log("report_id: ", report_id);
    const reportsData = await getClientReportGroup(
      auth.getAccount(),
      auth.getToken()
    );
    console.log("getAgentGroups: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({ tableLoaderClients: false });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        clientGroupData: reportsData.data.data,
        tableLoaderClients: false,
        columnsArrayClient: [
          { name: "seqno", label: "Seq #" },
          { name: "group_name", label: "Group Name" },
          /*{
          name: "id",
          label: "Assigned Reports",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setReportLink(value, tableMeta)}</div>;
            },
          },
        },*/
          {
            name: "group_desc",
            label: "Group Description",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.setGroupDesc(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.setStatus(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "id",
            label: "Action",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.setEditLink(value, "clients")}</div>;
              },
            },
          },
        ],
      });
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({ tableLoaderClients: false });
    }
  };

  openAddGroupModal = async (groupType) => {
    let modalTitle = "";
    let modalText = "";
    if (groupType === "agents") {
      modalTitle =
        "Add New " + localization.specificPortals.agentLabel + " Reports Group";
      modalText =
        "Enter the group details and select the " +
        localization.specificPortals.agentText +
        " reports from the list below.";
    } else if (groupType === "clients") {
      modalTitle = "Add New Client Reports Group";
      modalText =
        "Enter the group details and select the client reports from the list below.";
    } else if (groupType === "admin") {
      modalTitle = "Add New Admin Reports Group";
      modalText =
        "Enter the group details and select the admin reports from the list below.";
    }
    this.setState({
      groupType: groupType,
      modalTitle: modalTitle,
      modalText: modalText,
    });

    const reportsData = await getAllReportsListing(
      auth.getAccount(),
      auth.getToken(),
      groupType
    );
    console.log("getAllReportsListing: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      let clients = Array.isArray(reportsData?.data?.data)
        ? reportsData.data.data.map((client) => ({
            value: client.id,
            label: client.title,
          }))
        : [];

      /*const selectedClients = reportsData.data.selected_clients.map(
        (client) => client.id
      );*/
      const selectedClients = Array.isArray(reportsData?.data?.selected_clients)
        ? reportsData.data.selected_clients.map((client) => client.id)
        : [];

      const selectAllClients =
        clients.length > 0 &&
        clients.every((client) => selectedClients.includes(client.value));

      this.setState({
        combinedReportListing: reportsData.data.data,
        clientsList: clients,
        selectedClients: selectedClients,
        selectAllClients: selectAllClients,
        tableLoader: false,
      });
    } else {
      // console.log("Last: ", reportsData.data);
    }

    window.$("#modalAddGroup").modal("show");
  };

  add_new_group = async () => {
    const {
      selectedClients,
      group_name,
      group_status,
      group_desc,
      groupType,
      group_seqno,
    } = this.state;
    this.setState({
      add_funds_button: true,
      fundErrorMessage: "",
      fundSuccessMessage: "",
    });
    if (group_seqno === "") {
      this.setState({
        add_funds_button: false,
        fundErrorMessage: "Seq # is required.",
        fundErrorMessageTitle: "Missing Field",
      });
    } else if (group_name === "") {
      this.setState({
        add_funds_button: false,
        fundErrorMessage: "Group name is required.",
        fundErrorMessageTitle: "Missing Field",
      });
    } else if (group_desc === "") {
      this.setState({
        add_funds_button: false,
        fundErrorMessage: "Group description is required.",
        fundErrorMessageTitle: "Missing Field",
      });
    } else {
      console.log("add_new_group Start");
      const reportsData = await addReportsGroup(
        auth.getAccount(),
        auth.getToken(),
        groupType,
        group_name,
        group_status,
        group_desc,
        group_seqno,
        auth.getUserType(),
        auth.getSubUserAccount(),
        selectedClients
      );
      console.log("add_new_group: ", reportsData.data);

      if (
        reportsData.data.status === 403 ||
        reportsData.data.errors === "authentication missing" ||
        reportsData.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        reportsData.data.status === 404 &&
        reportsData.data.message === "Report not found."
      ) {
        this.setState({
          add_funds_button: false,
          fundErrorMessage: "There is some error while adding the group.",
          fundErrorMessageTitle: "System Error",
        });
      } else if (
        reportsData.data.status === 200 &&
        reportsData.data.message === "success"
      ) {
        this.setState({
          add_funds_button: false,
          fundErrorMessage: "",
          fundErrorMessageTitle: "",
          fundSuccessMessage:
            "Reports group added successfully. Please wait while we refresh the page.",
        });
        //console.log("groupType: ", groupType);
        if (groupType === "admin") {
          localStorage.setItem("groupMenuTab", "admin_groups");
        } else if (groupType === "agents") {
          localStorage.setItem("groupMenuTab", "agent_groups");
        } else if (groupType === "clients") {
          localStorage.setItem("groupMenuTab", "client_groups");
        }
        setTimeout(() => {
          this.setState({
            add_funds_button: false,
            fundErrorMessage: "",
            fundErrorMessageTitle: "",
            fundSuccessMessage: "",
          });
          window.location.reload();
        }, 4000);
      } else {
        this.setState({
          add_funds_button: false,
          fundErrorMessage: "There is some error while adding the group.",
          fundErrorMessageTitle: "System Error",
        });
      }
    }
    setTimeout(() => {
      this.setState({
        add_funds_button: false,
        fundErrorMessage: "",
        fundErrorMessageTitle: "",
        fundSuccessMessage: "",
      });
    }, 4000);
  };

  openEditGroupModal = async (group_id, groupType) => {
    let modalTitle = "";
    let modalText = "";
    if (groupType === "agents") {
      modalTitle =
        "Update " + localization.specificPortals.agentLabel + " Reports Group";
      modalText =
        "Enter the group details and select the " +
        localization.specificPortals.agentText +
        " reports from the list below.";
    } else if (groupType === "clients") {
      modalTitle = "Update Client Reports Group";
      modalText =
        "Enter the group details and select the client reports from the list below.";
    } else if (groupType === "admin") {
      modalTitle = "Update Admin Reports Group";
      modalText =
        "Enter the group details and select the admin reports from the list below.";
    }
    this.setState({
      groupType: groupType,
      modalTitleEdit: modalTitle,
      modalTextEdit: modalText,
      group_id_edit: group_id,
    });

    const reportsData = await getSingleGroup(
      auth.getAccount(),
      auth.getToken(),
      group_id,
      groupType
    );
    console.log("getSingleGroup: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "group_not_found"
    ) {
      //window.location.replace("/error");
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      let clients = Array.isArray(reportsData?.data?.all_reports)
        ? reportsData.data.all_reports.map((client) => ({
            value: client.id,
            label: client.title,
          }))
        : [];

      /*const selectedClients = reportsData.data.selected_clients.map(
        (client) => client.id
      );*/
      const selectedClients = Array.isArray(reportsData?.data?.assignedReports)
        ? reportsData.data.assignedReports.map((client) => client.report_id)
        : [];

      const selectAllClients =
        clients.length > 0 &&
        clients.every((client) => selectedClients.includes(client.value));

      let status = "active";
      if (reportsData.data.data[0]["status"] === 0) {
        status = "inactive";
      }
      this.setState({
        group_name_edit: reportsData.data.data[0]["group_name"],
        group_seqno_edit: reportsData.data.data[0]["seqno"],
        group_status_edit: status,
        group_desc_edit: reportsData.data.data[0]["group_desc"],
        reportList: clients,
        selectedReports: selectedClients,
        selectAllReports: selectAllClients,
        tableLoader: false,
      });
    } else {
      // console.log("Last: ", reportsData.data);
    }

    window.$("#modalEditGroup").modal("show");
  };

  update_new_group = async () => {
    const {
      selectedReports,
      group_name_edit,
      group_status_edit,
      group_desc_edit,
      groupType,
      group_seqno_edit,
      group_id_edit,
    } = this.state;
    this.setState({
      add_funds_button: true,
      fundErrorMessage: "",
      fundSuccessMessage: "",
    });
    if (group_seqno_edit === "") {
      this.setState({
        add_funds_button: false,
        fundErrorMessage: "Seq # is required.",
        fundErrorMessageTitle: "Missing Field",
      });
    } else if (group_name_edit === "") {
      this.setState({
        add_funds_button: false,
        fundErrorMessage: "Group name is required.",
        fundErrorMessageTitle: "Missing Field",
      });
    } else if (group_desc_edit === "") {
      this.setState({
        add_funds_button: false,
        fundErrorMessage: "Group description is required.",
        fundErrorMessageTitle: "Missing Field",
      });
    } else {
      const reportsData = await updateReportsGroup(
        auth.getAccount(),
        auth.getToken(),
        group_id_edit,
        groupType,
        group_name_edit,
        group_status_edit,
        group_desc_edit,
        group_seqno_edit,
        auth.getUserType(),
        auth.getSubUserAccount(),
        selectedReports
      );
      console.log("update_new_group: ", reportsData.data);

      if (
        reportsData.data.status === 403 ||
        reportsData.data.errors === "authentication missing" ||
        reportsData.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        reportsData.data.status === 404 &&
        reportsData.data.message === "Report not found."
      ) {
        this.setState({
          add_funds_button: false,
          fundErrorMessage: "There is some error while updating the group.",
          fundErrorMessageTitle: "System Error",
        });
      } else if (
        reportsData.data.status === 200 &&
        reportsData.data.message === "success"
      ) {
        this.setState({
          add_funds_button: false,
          fundErrorMessage: "",
          fundErrorMessageTitle: "",
          fundSuccessMessage:
            "Reports group updated successfully. Please wait while we refresh the page.",
        });
        //console.log("groupType: ", groupType);
        if (groupType === "admin") {
          localStorage.setItem("groupMenuTab", "admin_groups");
        } else if (groupType === "agents") {
          localStorage.setItem("groupMenuTab", "agent_groups");
        } else if (groupType === "clients") {
          localStorage.setItem("groupMenuTab", "client_groups");
        }
        setTimeout(() => {
          this.setState({
            add_funds_button: false,
            fundErrorMessage: "",
            fundErrorMessageTitle: "",
            fundSuccessMessage: "",
          });
          window.location.reload();
          //window.$("#modalEditGroup").modal("hide");
        }, 4000);
      } else {
        this.setState({
          add_funds_button: false,
          fundErrorMessage: "There is some error while updating the group.",
          fundErrorMessageTitle: "System Error",
        });
      }
    }
    setTimeout(() => {
      this.setState({
        add_funds_button: false,
        fundErrorMessage: "",
        fundErrorMessageTitle: "",
        fundSuccessMessage: "",
      });
    }, 4000);
  };

  handleChangeSearch = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);

    if (changed_value) {
      this.setState(
        (prevState) => ({
          selected_report_id: changed_value.value,
          selected_client_accountno: changed_value,
        }),
        () => {
          // This callback function is called right after the state is updated
          // console.log("Updated state:", this.state.client_accountno);
        }
      );
    } else {
      this.setState(
        {
          selected_report_id: null,
          selected_client_accountno: null,
        },
        () => {
          // console.log("Cleared selection");
        }
      );
    }
  };

  format_date = (value) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  setStatus = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === 1) {
      return (
        <div>
          <span className="badge badge-success">
            {" "}
            <em className="icon ni ni-done "></em> Active
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-danger">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> Inactive
          </span>
        </div>
      );
    }
  };

  setStatusPublished = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === 0) {
      return (
        <div>
          <span className="badge badge-dim badge-danger">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> Not
            Published
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-success">
            {" "}
            <em className="icon ni ni-done "></em> Published
          </span>
        </div>
      );
    }
  };

  setGroupDesc = (value, tableMeta) => {
    let domain_str = value;
    if (domain_str !== "") {
      return (
        <Tooltip title={domain_str} placement="top">
          <span
            className="badge badge-outline-primary"
            style={{ cursor: "context-menu" }}
          >
            {" "}
            <em className="icon ni ni-file-text"></em> View Description
          </span>
        </Tooltip>
      );
    } else {
      return "---";
    }
  };

  setReportLink = (value, tableMeta) => {
    let domain_str = value;
    let report_id = tableMeta.rowData[6];
    let is_published = tableMeta.rowData[4];
    //console.log("domain_str: ", domain_str);
    if (domain_str && domain_str !== "") {
      if (is_published === 1) {
        return (
          <>
            <Tooltip title="View / Assign reports" placement="top">
              <a
                href={`${APP_URL}viewAdminReport/${report_id}`}
                style={{
                  cursor: "pointer",
                  marginLeft: "5px",
                }}
              >
                <span className="badge badge-outline-primary">
                  {" "}
                  <em className="icon ni ni-done "></em> View / Assign
                </span>
              </a>
            </Tooltip>
          </>
        );
      } else {
        return "---";
      }
    } else {
      return "---";
    }
  };

  setEditLink = (value, groupType) => {
    let domain_str = value;
    //console.log("groupType: ", groupType);
    if (domain_str && domain_str !== "") {
      return (
        <>
          <Tooltip title="Edit Group">
            <a
              onClick={() => this.openEditGroupModal(domain_str, groupType)}
              style={{ cursor: "pointer" }}
            >
              <em
                className="icon ni ni-edit text-primary"
                style={{ fontSize: "22px", paddingRight: "5px" }}
              ></em>
            </a>
          </Tooltip>

          <Tooltip title="Delete Group">
            <a
              onClick={() => this.deleteGroupModal(domain_str, groupType)}
              style={{ cursor: "pointer" }}
            >
              <em
                className="icon ni ni-trash text-danger"
                style={{
                  fontSize: "22px",
                  paddingLeft: "5px",
                  borderLeft:
                    this.state.permission_edit === 1
                      ? "1px solid rgb(0 0 0 / 87%)"
                      : "none",
                }}
              ></em>
            </a>
          </Tooltip>
        </>
      );
    } else {
      return "---";
    }
  };

  deleteGroupModal = async (group_id, groupType) => {
    // console.log("deleteReportModal report_id: ", report_id);
    this.setState({
      request_main_section: false,
      group_id: group_id,
      groupTypeDel: groupType,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
      delete_button_loader: false,
    });
    window.$("#modalRequests").modal("show");
  };

  deleteGroup = async () => {
    const { group_id, groupTypeDel } = this.state;
    this.setState({
      diabled: true,
      group_id: group_id,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
      delete_button_loader: true,
    });
    // console.log("report_id: ", report_id);
    const reportsData = await deleteGroup(
      auth.getAccount(),
      auth.getToken(),
      group_id,
      groupTypeDel,
      auth.getUserType(),
      auth.getSubUserAccount()
    );
    // console.log("deleteReport: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({
        delete_button_loader: false,
        requestErrorMessage: "Report not found.",
        requestErrorMessageTitle: "Error",
        requestSuccessMessage: "",
      });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        requestErrorMessage: "",
        requestErrorMessageTitle: "",
        requestSuccessMessage:
          "Report deleted successfully. Please wait while we refresh the page.",
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({
        diabled: false,
        requestErrorMessage: "There is some error while deleting the report.",
        requestErrorMessageTitle: "System Error",
        requestSuccessMessage: "",
        delete_button_loader: false,
      });
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  formatOrderno = (value) => {
    return (
      <a
        href={`${APP_URL}ViewSalesOrder/${value}`}
        className="text-primary"
        target="_blank"
      >
        {value}
      </a>
    );
  };

  formatCommission = (value) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: value,
        }}
      />
    );
  };

  onSelect = (value) => {
    this.setState({
      value,
      start_date: value.start.format("YYYY-MM-DD"),
      end_date: value.end.format("YYYY-MM-DD"),
      isOpen: false,
    });
  };

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  regenerate_report = async () => {};

  open_agent_requests = async (value, tableMeta) => {};

  open_deposit_request = async (value, tableMeta) => {};

  modalHideMarketingPDF = (id) => {
    window.$("#" + id).modal("hide");
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    // console.log("handleChange " + name + " " + value);
    this.setState({
      [name]: value,
    });
  };

  handleDateChange = async (date) => {
    await this.handleStatesDynamic(
      "start_date",
      date.toISOString().slice(0, 10)
    );
    // console.log("start_date " + this.state.start_date);
  };

  handleDateChangeEnd = async (date) => {
    await this.handleStatesDynamic("end_date", date.toISOString().slice(0, 10));
    // console.log("end_date " + this.state.end_date);
  };

  handleStatesDynamic = async (start_date, date) => {
    this.setState({
      [start_date]: date,
    });
  };

  handleStates = async (start_date, end_date) => {
    this.setState({
      start_date: start_date,
      end_date: end_date,
    });
  };

  capitalizeFirstLetters = (str) => {
    return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
      return letter.toUpperCase();
    });
  };

  formatAsCurrency = (amount) => {
    //console.log("amount: "+  typeof amount + " - " + amount);
    //console.log("amount: ", typeof amount);
    if (!amount) {
      amount = 0;
    }
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: this.billing_decimalPoint,
      maximumFractionDigits: this.billing_decimalPoint,
    });
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation selectedFiles PDF, DOC, DOCX, ZIP, TXT, PNG, JPEG, JPG
    const allowedFileTypes = [".png", ".jpg", ".jpeg", ".pdf"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (!allowedFileTypes.includes(`.${fileExtension}`)) {
      this.setState({
        uploadErrorMessage:
          "Invalid file type. Please select a valid file format.",
        uploadErrorTitle: "Invalid File",
        add_picture: "",
        add_picture_name: "",
      });
      return;
    }

    // File size validation (e.g., limit to 10MB)
    const maxSizeBytes = 10 * 1024 * 1024; // 10MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        uploadErrorMessage:
          "File size exceeds the limit (10MB). Please choose a smaller file.",
        uploadErrorTitle: "Invalid File",
        add_picture: "",
        add_picture_name: "",
      });
      return;
    }

    // Clear any previous errors
    this.setState({
      add_picture: selectedFile,
      uploadErrorMessage: "",
      uploadErrorTitle: "",
      add_picture_name: selectedFile.name,
    });
    //return true;
  };

  handleModalopen = () => {
    window.$("#modalInsertSalesOrder").modal("show");
  };

  handleFileUploadClick = () => {
    document.getElementById("fileInput").click();
  };

  parseExcelData = (data) => {
    try {
      const workbook = XLSX.read(data, { type: "binary" });
      return workbook;
    } catch (error) {
      console.error("Error parsing Excel data:", error);
      return null;
    }
  };

  parseSheetData = (sheet) => {
    const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    const headers = data[0]; // Assuming first row contains headers
    const rows = data.slice(1); // Exclude headers
    return rows.map((row) =>
      headers.reduce((acc, header, index) => {
        acc[header] = row[index];
        return acc;
      }, {})
    );
  };

  downloadPdfRfq = async (d_f_name) => {
    var url = d_f_name;
    //let file_name = this.extractFileNameFromUrl(d_f_name);
    url = APP_LIVE_URL + "files_data/kyc_signup/" + d_f_name;
    //console.log("downloadPdfRfq: ", url);
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = d_f_name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  handleRowSelection = (rows) => {
    // Update state with the selected rows
    this.setState({ selectedRows: rows });
    // console.log("Selected rows:", rows);
  };

  handleBulkActionChange = (event) => {
    const action = event.target.value;
    this.setState({ bulkAction: action });

    if (action === "approve") {
      this.handleApprove();
    } else if (action === "delete") {
      this.handleDelete();
    }
  };

  handleApprove = () => {
    const { selectedRows } = this.state;
    // console.log("Approve rows:", selectedRows);
    // Add your approve logic here
  };

  handleDelete = () => {
    const { selectedRows } = this.state;
    // console.log("Delete rows:", selectedRows);
    // Add your delete logic here
  };

  handleSelectAllClientsChange = () => {
    const { selectAllClients, clientsList } = this.state;
    if (selectAllClients) {
      this.setState({
        selectedClients: [],
        selectAllClients: false,
      });
    } else {
      const allClientValues = clientsList.map((client) => client.value);
      this.setState({
        selectedClients: allClientValues,
        selectAllClients: true,
      });
    }
  };

  handleClientChange = (event, newSelectedOptions) => {
    const newSelectedClients = newSelectedOptions.map((option) => option.value);

    const selectAllClients =
      this.state.clientsList.length > 0 &&
      this.state.clientsList.length === newSelectedClients.length;

    this.setState({
      selectedClients: newSelectedClients,
      selectAllClients: selectAllClients,
    });
  };

  handleSelectAllReportChange = () => {
    const { selectAllReports, reportList } = this.state;
    if (selectAllReports) {
      this.setState({
        selectedReports: [],
        selectAllReports: false,
      });
    } else {
      const allClientValues = reportList.map((client) => client.value);
      this.setState({
        selectedReports: allClientValues,
        selectAllReports: true,
      });
    }
  };

  handleReportChange = (event, newSelectedOptions) => {
    const newSelectedClients = newSelectedOptions.map((option) => option.value);

    const selectAllClients =
      this.state.reportList.length > 0 &&
      this.state.reportList.length === newSelectedClients.length;

    this.setState({
      selectedReports: newSelectedClients,
      selectAllReports: selectAllClients,
    });
  };

  render() {
    //  let tableTitle = this.props.props.match.params.api_url.replaceAll("_", " ");
    const Theme = {
      palette: {
        primary: {
          contrastText: "#FFFFFF",
          dark: "#000000",
          main: "#000000",
          light: "#000000",
        },
      },
    };
    const { isOpen, value, start_date, end_date } = this.state;
    const formattedDateRange = start_date ? `${start_date} - ${end_date}` : "";
    const options = {
      selectableRows: "multiple", // Enable checkboxes for row selection
    };
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle
                        name="Report Groups"
                        icon="icon ni ni-reports"
                      />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContentAgent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <div className="dropdown">
                              <a
                                href="#"
                                className="btn btn-large btn-primary"
                                data-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <span>Add New Groups</span>
                                <em className="icon ni ni-chevron-down"></em>
                              </a>
                              <div className="dropdown-menu dropdown-menu-right dropdown-menu-auto mt-1">
                                <ul className="link-list-plain">
                                  <li>
                                    <a
                                      style={{
                                        cursor: "pointer",
                                        paddingLeft: "10px",
                                      }}
                                      onClick={() => {
                                        this.openAddGroupModal("admin");
                                      }}
                                    >
                                      <span>
                                        <em className="icon ni ni-plus"></em>{" "}
                                        Add Admin Group
                                      </span>
                                    </a>
                                  </li>

                                  <li>
                                    <a
                                      style={{
                                        cursor: "pointer",
                                        paddingLeft: "10px",
                                      }}
                                      onClick={() => {
                                        this.openAddGroupModal("agents");
                                      }}
                                    >
                                      <span>
                                        <em className="icon ni ni-plus"></em>{" "}
                                        Add{" "}
                                        {
                                          localization.specificPortals
                                            .agentLabel
                                        }{" "}
                                        Group
                                      </span>
                                    </a>
                                  </li>

                                  <li>
                                    <a
                                      style={{
                                        cursor: "pointer",
                                        paddingLeft: "10px",
                                      }}
                                      onClick={() => {
                                        this.openAddGroupModal("clients");
                                      }}
                                    >
                                      <span>
                                        <em className="icon ni ni-plus"></em>{" "}
                                        Add Client Group
                                      </span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-4">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          <ul className="nav nav-tabs">
                            <li className="nav-item">
                              <a
                                className={`nav-link ${
                                  this.state.groupMenuTab === "admin_groups"
                                    ? "active"
                                    : ""
                                }`}
                                data-toggle="tab"
                                onClick={() => {
                                  localStorage.setItem(
                                    "groupMenuTab",
                                    "admin_groups"
                                  );
                                  this.getAdminGroups();
                                }}
                                href="#adminGroups"
                              >
                                <em className="icon ni ni-reports"></em>
                                <span>Admin Groups</span>
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className={`nav-link ${
                                  this.state.groupMenuTab === "agent_groups"
                                    ? "active"
                                    : ""
                                }`}
                                data-toggle="tab"
                                onClick={() => {
                                  localStorage.setItem(
                                    "groupMenuTab",
                                    "agent_groups"
                                  );
                                  this.getAgentGroups();
                                }}
                                href="#agentGroups"
                              >
                                <em className="icon ni ni-reports"></em>
                                <span>
                                  {localization.specificPortals.agentLabel}{" "}
                                  Groups
                                </span>
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className={`nav-link ${
                                  this.state.groupMenuTab === "client_groups"
                                    ? "active"
                                    : ""
                                }`}
                                data-toggle="tab"
                                onClick={() => {
                                  localStorage.setItem(
                                    "groupMenuTab",
                                    "client_groups"
                                  );
                                  this.getClientGroups();
                                }}
                                href="#clientGroups"
                              >
                                <em className="icon ni ni-reports"></em>
                                <span>Client Groups</span>
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content">
                            <div
                              className={`tab-pane ${
                                this.state.groupMenuTab === "admin_groups"
                                  ? "active"
                                  : ""
                              }`}
                              id="adminGroups"
                            >
                              {this.state.tableLoader === true ? (
                                tableLoader()
                              ) : (
                                <>
                                  <div className="d-flex justify-content-end">
                                    <a
                                      href="/adminReports"
                                      target="_blank"
                                      className="btn btn-dim btn-outline-primary"
                                    >
                                      <span>Admin Reports</span>{" "}
                                      <em className="icon ni ni-external-alt"></em>
                                    </a>
                                  </div>
                                  <DataTable
                                    columns={this.state.columnsArray}
                                    tableData={this.state.adminGroupData}
                                    title=""
                                    //options={options}
                                    //onRowSelection={this.handleRowSelection}
                                  />
                                </>
                              )}
                            </div>
                            <div
                              className={`tab-pane ${
                                this.state.groupMenuTab === "agent_groups"
                                  ? "active"
                                  : ""
                              }`}
                              id="agentGroups"
                            >
                              {this.state.tableLoaderAgents === true ? (
                                tableLoader()
                              ) : (
                                <>
                                  <div className="d-flex justify-content-end">
                                    <a
                                      href="/agentReports"
                                      target="_blank"
                                      className="btn btn-dim btn-outline-primary"
                                    >
                                      <span>
                                        {
                                          localization.specificPortals
                                            .agentLabel
                                        }{" "}
                                        Reports
                                      </span>{" "}
                                      <em className="icon ni ni-external-alt"></em>
                                    </a>
                                  </div>
                                  <DataTable
                                    columns={this.state.columnsArrayAgent}
                                    tableData={this.state.agentGroupData}
                                    title=""
                                    //options={options}
                                    //onRowSelection={this.handleRowSelection}
                                  />
                                </>
                              )}
                            </div>
                            <div
                              className={`tab-pane ${
                                this.state.groupMenuTab === "client_groups"
                                  ? "active"
                                  : ""
                              }`}
                              id="clientGroups"
                            >
                              {this.state.tableLoaderClients === true ? (
                                tableLoader()
                              ) : (
                                <>
                                  <div className="d-flex justify-content-end">
                                    <a
                                      href="/metabaseReports"
                                      target="_blank"
                                      className="btn btn-dim btn-outline-primary"
                                    >
                                      <span>Client Reports</span>{" "}
                                      <em className="icon ni ni-external-alt"></em>
                                    </a>
                                  </div>
                                  <DataTable
                                    columns={this.state.columnsArrayClient}
                                    tableData={this.state.clientGroupData}
                                    title=""
                                    //options={options}
                                    //onRowSelection={this.handleRowSelection}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* START DATATABLE */}

                      {/* END TABLE */}
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                  {/* Link Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalAddGroup"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              {this.state.modalTitle}
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingPDF("modalAddGroup");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          <div className="row g-gs">
                            {this.state.fundSuccessMessage !== "" ? (
                              <div className="col-sm-12">
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h6>Success</h6>
                                    <p>{this.state.fundSuccessMessage}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.fundErrorMessage !== "" ? (
                              <div className="col-sm-12">
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h6>{this.state.fundErrorMessageTitle}</h6>
                                    <p>{this.state.fundErrorMessage}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            <div className="col-sm-12">
                              <p>{this.state.modalText}</p>
                            </div>
                            <div className="col-sm-12">
                              <div className="row g-4">
                                <div className="col-md-12 col-lg-12 col-xl-12">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        Group Title <sup>*</sup>
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="group_name"
                                        name="group_name"
                                        type="text"
                                        label=""
                                        value={this.state.group_name}
                                        onChange={this.handleChange}
                                        inputProps={{
                                          maxLength: 64, // Set the maximum length to 10 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                    <div className="form-note">
                                      Maximum 64 characters
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-xl-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        Sequence # <sup>*</sup>
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="group_seqno"
                                        name="group_seqno"
                                        type="text"
                                        label=""
                                        value={this.state.group_seqno}
                                        onChange={this.handleChange}
                                        onKeyPress={() => {
                                          this.checkNumber();
                                        }}
                                        inputProps={{
                                          maxLength: 4, // Set the maximum length to 4 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                    <div className="form-note">
                                      Maximum 64 characters
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-xl-6">
                                  <div className="form-group">
                                    <label className="form-label">Status</label>
                                    <div className="form-control-wrap">
                                      <MutextField
                                        id="group_status"
                                        name="group_status"
                                        select
                                        label=""
                                        value={this.state.group_status}
                                        onChange={this.handleChange}
                                        SelectProps={{
                                          native: true,
                                        }}
                                        helperText="Select the group status here."
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      >
                                        <option key="5" value="active">
                                          Active
                                        </option>
                                        <option key="10" value="inactive">
                                          Inactive
                                        </option>
                                      </MutextField>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        Choose Report{" "}
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              this.state.selectAllClients
                                            }
                                            onChange={
                                              this.handleSelectAllClientsChange
                                            }
                                            color="primary"
                                          />
                                        }
                                        label="Select all reports"
                                        style={{
                                          width: "max-content",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      <Autocomplete
                                        multiple
                                        id="clients-autocomplete"
                                        options={this.state.clientsList}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) =>
                                          option.label
                                        }
                                        value={this.state.clientsList.filter(
                                          (c) =>
                                            this.state.selectedClients.includes(
                                              c.value
                                            )
                                        )}
                                        onChange={this.handleClientChange}
                                        renderOption={(
                                          option,
                                          { selected }
                                        ) => (
                                          <Fragment>
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selected}
                                            />
                                            {option.label}
                                          </Fragment>
                                        )}
                                        style={{ width: "100%" }}
                                        renderInput={(params) => (
                                          <MutextField
                                            {...params}
                                            label="Select Reports"
                                          autoComplete="new-password"
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-12 mt-2">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="emailcontent"
                                >
                                  Description <sup>*</sup>
                                </label>
                                <div className="form-control-wrap">
                                  <textarea
                                    className="form-control"
                                    id="group_desc"
                                    name="group_desc"
                                    value={this.state.group_desc}
                                    onChange={this.handleChange}
                                    placeholder="Add description of the group with a maximum of 500 characters.."
                                    maxLength="500"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 mt-2 d-flex justify-content-end">
                              <div className="nk-block-head-content">
                                <ul className="nk-block-tools gx-3">
                                  {this.state.add_funds_button === true ? (
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Processing... </span>
                                    </button>
                                  ) : (
                                    <li>
                                      <a
                                        onClick={() => this.add_new_group()}
                                        style={{
                                          cursor: "pointer",
                                          color: "#fff",
                                        }}
                                        className="btn btn-primary"
                                      >
                                        <em className="icon ni ni-check-round-cut"></em>{" "}
                                        <span>Add Group</span>{" "}
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>

                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* LINK MODAL End */}
                  {/* Link Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalEditGroup"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              {this.state.modalTitleEdit}
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingPDF("modalEditGroup");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          <div className="row g-gs">
                            {this.state.fundSuccessMessage !== "" ? (
                              <div className="col-sm-12">
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h6>Success</h6>
                                    <p>{this.state.fundSuccessMessage}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.fundErrorMessage !== "" ? (
                              <div className="col-sm-12">
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h6>{this.state.fundErrorMessageTitle}</h6>
                                    <p>{this.state.fundErrorMessage}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            <div className="col-sm-12">
                              <p>{this.state.modalTextEdit}</p>
                            </div>
                            <div className="col-sm-12">
                              <div className="row g-4">
                                <div className="col-md-12 col-lg-12 col-xl-12">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        Group Title <sup>*</sup>
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="group_name_edit"
                                        name="group_name_edit"
                                        type="text"
                                        label=""
                                        value={this.state.group_name_edit}
                                        onChange={this.handleChange}
                                        inputProps={{
                                          maxLength: 64, // Set the maximum length to 10 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                    <div className="form-note">
                                      Maximum 64 characters
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-xl-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        Sequence # <sup>*</sup>
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="group_seqno_edit"
                                        name="group_seqno_edit"
                                        type="text"
                                        label=""
                                        value={this.state.group_seqno_edit}
                                        onChange={this.handleChange}
                                        onKeyPress={() => {
                                          this.checkNumber();
                                        }}
                                        inputProps={{
                                          maxLength: 4, // Set the maximum length to 4 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                    <div className="form-note">
                                      Maximum 64 characters
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-xl-6">
                                  <div className="form-group">
                                    <label className="form-label">Status</label>
                                    <div className="form-control-wrap">
                                      <MutextField
                                        id="group_status_edit"
                                        name="group_status_edit"
                                        select
                                        label=""
                                        value={this.state.group_status_edit}
                                        onChange={this.handleChange}
                                        SelectProps={{
                                          native: true,
                                        }}
                                        helperText="Select the group status here."
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      >
                                        <option key="51" value="active">
                                          Active
                                        </option>
                                        <option key="11" value="inactive">
                                          Inactive
                                        </option>
                                      </MutextField>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        Choose Report{" "}
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              this.state.selectAllReports
                                            }
                                            onChange={
                                              this.handleSelectAllReportChange
                                            }
                                            color="primary"
                                          />
                                        }
                                        label="Select all reports"
                                        style={{
                                          width: "max-content",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      <Autocomplete
                                        multiple
                                        id="clients-autocomplete"
                                        options={this.state.reportList}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) =>
                                          option.label
                                        }
                                        value={this.state.reportList.filter(
                                          (c) =>
                                            this.state.selectedReports.includes(
                                              c.value
                                            )
                                        )}
                                        onChange={this.handleReportChange}
                                        renderOption={(
                                          option,
                                          { selected }
                                        ) => (
                                          <Fragment>
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selected}
                                            />
                                            {option.label}
                                          </Fragment>
                                        )}
                                        style={{ width: "100%" }}
                                        renderInput={(params) => (
                                          <MutextField
                                            {...params}
                                            label="Select Reports"
                                          autoComplete="new-password"
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-12 mt-2">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="emailcontent"
                                >
                                  Description <sup>*</sup>
                                </label>
                                <div className="form-control-wrap">
                                  <textarea
                                    className="form-control"
                                    id="group_desc_edit"
                                    name="group_desc_edit"
                                    value={this.state.group_desc_edit}
                                    onChange={this.handleChange}
                                    placeholder="Add description of the group with a maximum of 500 characters.."
                                    maxLength="500"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 mt-2 d-flex justify-content-end">
                              <div className="nk-block-head-content">
                                <ul className="nk-block-tools gx-3">
                                  {this.state.add_funds_button === true ? (
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Processing... </span>
                                    </button>
                                  ) : (
                                    <li>
                                      <a
                                        onClick={() => this.update_new_group()}
                                        style={{
                                          cursor: "pointer",
                                          color: "#fff",
                                        }}
                                        className="btn btn-primary"
                                      >
                                        <em className="icon ni ni-check-round-cut"></em>{" "}
                                        <span>Update Group</span>{" "}
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>

                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* LINK MODAL End */}
                  {/* Link Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalRequests"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em> Delete
                              Group
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingPDF("modalRequests");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          {this.state.request_main_section === true ? (
                            FormLoader()
                          ) : (
                            <div className="row g-gs">
                              {this.state.requestErrorMessage !== "" ? (
                                <div className="col-sm-12">
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>
                                          {this.state.requestErrorMessageTitle}
                                        </h4>

                                        <p>{this.state.requestErrorMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.requestSuccessMessage !== "" ? (
                                <div className="col-sm-12">
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>

                                        <p>
                                          {this.state.requestSuccessMessage}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              <div className="col-sm-12">
                                <div className="card card-bordered mt-1">
                                  <div className="card-inner-group">
                                    <div className="card-inner">
                                      <div
                                        className="sp-plan-desc sp-plan-desc-mb"
                                        id="paymentMethodDetails"
                                      >
                                        <div id="no-more-tables-new">
                                          Are you sure you want to permanently
                                          delete this group? Deleting this group
                                          will also unassign any reports linked
                                          to it.
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-12">
                                <div className="d-flex justify-content-end">
                                  {this.state.delete_button_loader === true ? (
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Processing... </span>
                                    </button>
                                  ) : (
                                    <>
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          this.modalHideMarketingPDF(
                                            "modalRequests"
                                          );
                                        }}
                                        className="btn btn-light mr-2"
                                      >
                                        Cancel
                                      </a>
                                      <button
                                        type="button"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => this.deleteGroup()}
                                        className="btn btn-primary"
                                      >
                                        Delete
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* LINK MODAL End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportGroups);
